'use client';

import { UserDropdownMenu } from '@/app/components/partials/topbar/user-dropdown-menu';
import { cn } from '@/lib/utils';
import { CreditsPill } from '@/new_components/shared/CreditsPill';
import { NotificationsBell } from '@/new_components/notifications/NotificationsBell';
import { LanguageToggle } from '@/new_components/shared/LanguageToggle';

// `stable` renders the topbar in a fixed desktop config that doesn't change at
// the `lg`/`xl` breakpoints (language toggle always shown, fixed gaps). Both the
// fit-probe and the real desktop row pass it: the row is now shown/hidden by JS
// measurement, not a CSS breakpoint, so any internal breakpoint would (a) make
// the probe's width non-monotonic and flip the header, and (b) make the search
// visibly jump when the topbar collapses mid-range. See header.tsx.
//
// `compactAuth` (only meaningful with `stable`) collapses the logged-out
// Register/Login pills into the single profile icon, so the header can stay in
// desktop mode at narrower widths before falling back to the mobile header.
const HeaderTopbar = ({
  stable = false,
  compactAuth = false,
}: { stable?: boolean; compactAuth?: boolean } = {}) => {
  return (
    <div className={cn('flex items-center shrink-0', stable ? 'gap-2' : 'gap-1 lg:gap-2')}>
      {/* Credit balance + notification bell — ambient awareness next to the
          account entry point. Both render null for guests, so they never
          disturb the fit probe's logged-out measurements (see header.tsx). */}
      <CreditsPill />
      <NotificationsBell />

      {/* User dropdown — placed first so the language toggle ends up at the
          absolute right edge of the header. */}
      <div className="mr-1">
        <UserDropdownMenu stable={stable} compactAuth={compactAuth} />
      </div>

      {/* Language toggle at the absolute right edge. Hidden below lg unless
          `stable`; on mobile the toggle lives in the sidebar instead. */}
      <LanguageToggle stable={stable} />
    </div>
  );
};

export { HeaderTopbar };
